import type { JSONDocNode, JSONNode } from '@atlaskit/editor-json-transformer/types';

const MAX_NODES = 50_000;

const countWordsInText = (text?: string): number => text?.match(/\S+/g)?.length ?? 0;

/**
 * Counts the number of words in an editor document (the `JSONDocNode` returned by
 * `requestDocument`).
 */
export const countWordsInAdf = (doc: JSONDocNode | null | undefined): number => {
	if (!doc) {
		return 0;
	}

	let wordCount = 0;
	let nodeCount = 0;

	const visit = (node: JSONNode): void => {
		nodeCount += 1;
		if (nodeCount > MAX_NODES) {
			return;
		}
		if (node.type === 'expand' || node.type === 'nestedExpand') {
			return;
		}
		if (node.type === 'text') {
			wordCount += countWordsInText(node.text);
		}
		const children = node.content;
		if (children) {
			for (const child of children) {
				if (nodeCount > MAX_NODES) {
					break;
				}
				if (child) {
					// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- single pre-order DFS; each ADF node is visited exactly once (O(total nodes)), not quadratic
					visit(child);
				}
			}
		}
	};

	visit(doc);

	return wordCount;
};
